import { http } from '../../config/axios'

 const findPropostaCredito = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/propostacredito/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findPropostaCredito', error)
      throw Error(error.response.data)
    })
}

export default findPropostaCredito;
